import { tokens } from '@sail/ui';
export const chromaFlavorColor = {
    accentColor: tokens.color.brand[600],
    blendBackground: '#80e9ff',
    blendIntersection: '#0048e5',
    blendForeground: '#7a73ff',
    gradientColorZero: '#a960ee',
    gradientColorOne: '#ff333d',
    gradientColorTwo: '#90e0ff',
    gradientColorThree: '#ffcb57',
    gradientColorZeroTransparent: '#a960ee00',
    gradientColorOneTransparent: '#ff333d00',
    gradientColorTwoTransparent: '#90e0ff00',
    gradientColorThreeTransparent: '#ffcb5700',
    shadeOneColor: '#02bcf5',
    shadeTwoColor: '#0073e6',
    shadeThreeColor: '#003ab9',
    shadeFourColor: '#635bff',
    shadeFiveColor: '#002c59',
    shadeSixColor: '#09cbcb'
};
export const lightHelmColor = {
    gridLines: {
        dashed: 'rgba(66, 71, 112, 0.09)',
        solid: 'rgba(66, 71, 112, 0.06)'
    },
    annotationColor: '#8c9eb1',
    navColor: tokens.color.neutral[900],
    navHoverColor: tokens.color.neutral[900],
    navHoverOpacity: '0.6',
    cardBorderColor: tokens.color.neutral[300],
    subcardBackground: tokens.color.neutral[100],
    gridSubcardBackground: tokens.color.neutral[100],
    tableIconColor: '#8c9eb1',
    stripeAccentLight: tokens.color.neutral[200],
    stripeAccentDark: tokens.color.neutral[900],
    stripeAccentWhite: tokens.color.neutral[0],
    bulletColor: tokens.color.neutral[300],
    disclaimerTextColor: tokens.color.neutral[500],
    inlineCodeTextColor: tokens.color.neutral[800],
    inlineCodeBackground: tokens.color.neutral[200],
    socialLogoColor: tokens.color.neutral[300],
    socialLogoHoverColor: tokens.color.neutral[900],
    customerLogoColor: tokens.color.neutral[400]
};
export const customColorTokens = {
    ...lightHelmColor,
    ...chromaFlavorColor
}; // TODO: remove this once further color tokens are applied
 // Token audit:
 // const themeLight = {
 //   // color.background.surface
 //   backgroundColor: '#f6f9fc',
 //   // accentColor
 //   linkColor: 'var(--accentColor)',
 //   // keep for now
 //   linkHoverColor: '#0a2540',
 //   // keep for now
 //   linkHoverOpacity: 1,
 //   // color.text.action.primary
 //   buttonColor: 'var(--accentColor)',
 //   // color.text.action.primary.hovered
 //   buttonHoverColor: '#0a2540',
 //   // color.text.action.primary.disable
 //   buttonDisabledColor: '#cfd7df',
 //   // Keep or migrate to color/rgba
 //   buttonDisabledOpacity: '0.7',
 //   // color.text.onAction.primary
 //   knockoutColor: '#ffffff',
 //   // color.text.onAction.primary.disabled
 //   knockoutDisabledColor: '#8898aa',
 //   // KEEP
 //   guideSolidColor: 'rgba(66, 71, 112, 0.06)',
 //   // KEEP
 //   guideDashedColor: 'rgba(66, 71, 112, 0.09)',
 //   // color.text.emphasized
 //   titleColor: '#0a2540',
 //   // color.text
 //   textColor: '#425466',
 //   // color.text.form
 //   formFieldDescriptionTextColor: '#3f4b66',
 //   // color.background.form
 //   inputBackground: '#f6f9fc',
 //   // TODO:
 //   checkboxInputBackground: '#e7ecf1',
 //   // color.text.form.placeholder
 //   inputPlaceholderColor: '#727f96',
 //   // color.text.form
 //   inputTextColor: '#0a2540',
 //   // color.text.form.placeholder
 //   inputErrorAccentColor: '#ff5996',
 //   // keep
 //   annotationColor: '#8c9eb1',
 //   // delete (always the same value in helm regardless of theme)
 //   maskFadeColor: 'rgba(0, 0, 0, 0.4)',
 //   // keep
 //   navColor: '#0a2540',
 //   // keep
 //   navHoverColor: '#0a2540',
 //   // keep
 //   navHoverOpacity: '0.6',
 //   // delete ( this should not be needed )
 //   footerColor: '#0a2540',
 //   // color.border
 //   cardBorderColor: '#cbd6e0',
 //   // color.background.offset
 //   cardBackground: '#ffffff',
 //   // keep/review the need
 //   subcardBackground: '#f6f9fc',
 //   // keep
 //   /* Background for Cards/Highlighted content in the grid and without shadows */
 //   gridSubcardBackground: '#ffffff',
 //   // color.icon.subdued
 //   tableIconColor: '#8c9eb1',
 //   // delete (always the same value in helm regardless of theme)
 //   stripeAccentWhite: '#ffffff',
 //   // keep (used for stripeset)
 //   stripeAccentLight: '#e3e7ec',
 //   // delete (always the same value in helm regardless of theme)
 //   stripeAccentDark: '#0a2540',
 //   // keep
 //   bulletColor: '#cfd7df',
 //   // color.text.subdued
 //   footnoteTextColor: '#4d5b78',
 //   // keep
 //   disclaimerTextColor: '#707f98',
 //   // keep
 //   inlineCodeTextColor: '#2c3a57',
 //   // keep
 //   inlineCodeBackground: '#dce6ee',
 //   // keep
 //   socialLogoColor: '#c4ccd8',
 //   // keep
 //   socialLogoHoverColor: '#0a2540',
 // };

//# sourceMappingURL=customColor.js.map